import { render, staticRenderFns } from "./UserCardSvg.vue?vue&type=template&id=577686db"
import script from "./UserCardSvg.vue?vue&type=script&lang=js"
export * from "./UserCardSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports